/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {ModeloGpsFormComponent} from "./modelo-gps-form/modelo-gps-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";
import {ModeloGpsListComponent} from "./modelo-gps-list/modelo-gps-list.component";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class ModeloGpsRoutingModule {}

export const modeloGpsRoutes: any[] = [
    {
        path: '',
        component: ModeloGpsListComponent
    },{
        path: editRoute + '/:id',
        component: ModeloGpsFormComponent
    },{
        path: newRoute,
        component: ModeloGpsFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/modelos-gps-routing.module.ts
 **/